import { render, staticRenderFns } from "./internationalization.vue?vue&type=template&id=84e8a40a&scoped=true&"
import script from "./internationalization.vue?vue&type=script&lang=js&"
export * from "./internationalization.vue?vue&type=script&lang=js&"
import style0 from "./internationalization.vue?vue&type=style&index=0&id=84e8a40a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e8a40a",
  null
  
)

export default component.exports